import { Redirect, Session } from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { UUID } from 'smg/uuid';
import { CheckPOBoxAddress, Draw, PromptNew } from '../shippingoptions';

export default async function main() {
    if (await Redirect()) {
        return;
    }
    const sess = await Session();
    const cardContainer = document.querySelector<HTMLElement>('#shipping-options-container');

    const newAddressBtn = document.querySelector('#new-address');
    newAddressBtn?.addEventListener('click', () => {
        void PromptNew(sess).then(drawAddress);
    });

    const shippingOptions = await shippingoptions.GetShippingOptions({
        'data': 'fullName,company,addressLine1,addressLine1,city,stateID,zip,countryID,phone,email',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip',
    });

    const drawAddress = async (option: models.ShippingOption) => {
        const addressEl = (await Draw(option)).querySelector<HTMLElement>('address');
        const cardEl = template.Clone('#card-template').firstElementChild as HTMLElement;
        const addressContainer = cardEl.querySelector('.address-container') as HTMLElement;
        const editBtn = cardEl.querySelector('.edit-btn');
        const deleteBtn = cardEl.querySelector('.delete-btn');

        addressContainer?.append(addressEl as HTMLElement);

        editBtn?.addEventListener('click', async () => {
            await PromptNew(sess, option).then(newOption => {
                option = newOption;
                void Draw(newOption, addressEl as HTMLElement).then(res => {
                    void CheckPOBoxAddress(newOption.countryID as models.CountryID, newOption.stateID || 0, newOption.addressLine1 || '', res);
                });
            });
        });

        deleteBtn?.addEventListener('click', () => {
            void shippingoptions.DeleteShippingOption(option.id || '').
                then(() => {
                    cardEl.parentElement?.removeChild(cardEl);
                    const undoLinkID = `undo-${UUID()}`;
                    const t = toast.Success(`Removed shipping option. <a href="#" class="text-white text-decoration-underline" id="${undoLinkID}">Undo</a>`);
                    const undo = document.querySelector(`#${undoLinkID}`) as HTMLAnchorElement;
                    undo.addEventListener('click', e => {
                        e.preventDefault();
                        t?.dispose();
                        void shippingoptions.RestoreShippingOption(option.id || '');
                        void drawAddress(option);
                    });
                });
        });
        cardContainer?.insertBefore(cardEl, cardContainer.firstChild);
        void CheckPOBoxAddress(option.countryID as models.CountryID, option.stateID || 0, option.addressLine1 || '', addressEl as HTMLElement);
    };

    for (const shippingOption of shippingOptions) {
        await drawAddress(shippingOption);
    }
}